class Quiz extends HTMLElement {
  constructor() {
    super();
    this.Question1 = [];
    this.Question2 = [];
    this.Question3 = [];
    this.Question4 = [];
    this.Question5 = [];
    this.Question6 = [];
    this.loadFile();
    this.start_quiz_init();
    this.arrowBtnInit()
  }
  
  start_quiz_init(){
    const start_quiz = document.querySelectorAll('.start-quiz');
    
    start_quiz.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.querySelector('.cu-quiz-data-column-quizs').classList.remove('hide')
        this.querySelector('.starter').classList.add('hide')
      });
    });
  }

  question_1_init(){
    const questions_1 = this.querySelectorAll('[data-question="1"] .column-quizs-data_items .column-quizs-data_items_child');
    
    questions_1.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        var value = event.target.getAttribute('data-value');
        this.SetQuestion2(value);
      });
    });
  }

  question_2_init(){
    const questions_2 = this.querySelectorAll('[data-question="2"] .column-quizs-data_items .column-quizs-data_items_child');
    
    questions_2.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        var value = event.target.getAttribute('data-value');
        this.SetQuestion3(value);
      });
    });
  }

  question_3_init(){
    const questions_3 = this.querySelectorAll('[data-question="3"] .column-quizs-data_items .column-quizs-data_items_child');
    
    questions_3.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        var value = event.target.getAttribute('data-value');
        debugger
        this.SetQuestion4(value);
      });
    });
  }

  question_4_init(){
    const questions_4 = this.querySelectorAll('[data-question="4"] .column-quizs-data_items .column-quizs-data_items_child');
    
    questions_4.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        var value = event.target.getAttribute('data-value');
        this.SetQuestion5(value);
      });
    });
  }

  question_5_init(){
    const questions_5 = this.querySelectorAll('[data-question="5"] .column-quizs-data_items .column-quizs-data_items_child');
    
    questions_5.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        var value = event.target.getAttribute('data-value');
        this.SetQuestion6(value);
      });
    });
  }

  question_6_init(){
    const questions_6 = this.querySelectorAll('[data-question="6"] .column-quizs-data_items .column-quizs-data_items_child');
    
    questions_6.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        var value = event.target.getAttribute('data-value');
        this.SetProducts(value);
      });
    });
  }

  arrowBtnInit(){
    const barArrowPrev = this.querySelectorAll('.bar_arrows-prev');
    
    barArrowPrev.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.PrevSlide();
      });
    });

    const barArrowNext = this.querySelectorAll('.bar_arrows-next');
    
    barArrowNext.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.NextSlide();
      });
    });
  }

  PrevSlide(){
    var actived_slide = this.querySelector('.column-quizs-data_column:not(.hide)');
    
    actived_slide.previousElementSibling.classList.remove('hide');
    actived_slide.classList.add('hide');
    this.arrowBtn();
  }

  NextSlide(){
    var actived_slide = this.querySelector('.column-quizs-data_column:not(.hide)');
    
    actived_slide.nextElementSibling.classList.remove('hide');
    actived_slide.classList.add('hide');
    this.arrowBtn();
  }

  arrowBtn(){
    var actived_slides = this.querySelectorAll('.column-quizs-data_column.actived');
    var last_actived_slide = actived_slides[actived_slides.length-1];
    var fist_actived_slide = actived_slides[0];
    var actived_slide = this.querySelector('.column-quizs-data_column:not(.hide)');
    
    var actived_slide_next = false;
    var actived_slide_prev = false;
    
    if(actived_slide.nextElementSibling){
      var actived_slide_next = actived_slide.nextElementSibling.classList.contains('actived');
    }
    if(actived_slide.previousElementSibling){
      var actived_slide_prev = actived_slide.previousElementSibling.classList.contains('actived');
    }

    if(actived_slide_next){
      this.querySelector('.bar_arrows-next').classList.remove('disabled');
    }else{
      this.querySelector('.bar_arrows-next').classList.add('disabled');
    }
    if(actived_slide_prev){
      this.querySelector('.bar_arrows-prev').classList.remove('disabled');
    }else{
      this.querySelector('.bar_arrows-prev').classList.add('disabled');
    }

    this.ProgressBar();
  }

  ProgressBar(){
    var actived_slide = this.querySelector('.column-quizs-data_column:not(.hide)');
    var actived_slide_index = parseInt(actived_slide.getAttribute('data-question'));
    var getVariable = "Question" + actived_slide_index;
    var data = this[getVariable];
    
    var steps = 0;
    for (var j = 0; j < data.length; j++) {
      for (var e = 0; e < data[j].length-1; e++) {
        if (steps < e && data[j][e] != '') {
          steps++;
        }
      }
    }
    steps++;

    var progress = ((actived_slide_index - 0) / steps) * 100; // subtract 1 here
    progress = Math.max(0, parseFloat(progress.toFixed(2)));   // just in case it goes negative
    
    var bar = this.querySelector('.cu-quiz-data-column-quizs-progress_bar');
    
    bar.style.setProperty('--bar-width', progress + '%');
    bar.querySelector('.quizs-progress_bar_counter').textContent = Math.round(progress) + '% Complete';


  }

  loadFile(){
    $.ajax({
      type: "GET",
      url: cvs,
      dataType: "text",
      success: function(data) {
        this.SetQuestion1(data);
      }.bind(this) // bind 'this' to the current context
    });
  }

  SetQuestion1(allText){
    this.Question1 = [];
    var allTextLines = allText.split(/\r\n|\n/);
    for (var j=1; j<allTextLines.length; j++) {
      if(allTextLines[j] == ''){
      }else{
        debugger
        this.Question1.push(allTextLines[j].split(','));
      }
    }

    debugger
    var Question = this.Question1[0][0].split('::')[0];

    document.querySelector('[data-question-heading="1"]').innerHTML = Question;
    document.querySelector('[data-question="1"] .column-quizs-data_items').innerHTML = '';

    var Question1_item = []
    for (var j = 0; j < this.Question1.length; j++) {
      var optionText = this.Question1[j][0].split('::')[1].trim();
      var imageUrl = this.Question1[j][0].split('::')[2];
      var imgTag = (imageUrl && imageUrl !== 'undefined') ? `<img src="${imageUrl}"/>` : '';
      
      if (!Question1_item.includes(optionText)) {
        document.querySelector('[data-question="1"] .column-quizs-data_items').insertAdjacentHTML('beforeend', `
          <div class="column-quizs-data_items_child" data-value="${this.Question1[j][0]}">
            <span>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_8_1136)">
                  <path class="inner_circle" d="M12 6.46875C8.68797 6.46875 5.99995 9.15677 5.99995 12.4688C5.99995 15.7808 8.68797 18.4687 12 18.4687C15.312 18.4687 18 15.7807 18 12.4687C18 9.15671 15.312 6.46875 12 6.46875Z" fill="#ED1C24"></path>
                  <path d="M12 0.46875C5.37001 0.46875 0 5.83876 0 12.4687C0 19.0987 5.37001 24.4687 12 24.4687C18.6299 24.4687 24 19.0987 24 12.4687C24 5.83871 18.63 0.46875 12 0.46875ZM12 22.0687C6.69599 22.0687 2.39996 17.7728 2.39996 12.4687C2.39996 7.16469 6.69599 2.86877 12 2.86877C17.3039 2.86877 21.6 7.16474 21.6 12.4687C21.6 17.7727 17.304 22.0687 12 22.0687Z" fill="#ED1C24"></path>
                </g>
                <defs>
                  <clipPath id="clip0_8_1136">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.46875)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
            ${optionText}
            ${imgTag}
          </div>
        `);
        
        Question1_item.push(optionText);
      }
    }
    document.querySelector('[data-question="1"]').classList.add('actived');
    document.querySelector('[data-question="1"]').classList.remove('hide');
    document.querySelector('[data-question="2"]').classList.add('hide');
    document.querySelector('[data-question="3"]').classList.add('hide');
    document.querySelector('[data-question="4"]').classList.add('hide');
    document.querySelector('[data-question="5"]').classList.add('hide');
    document.querySelector('[data-question="6"]').classList.add('hide');

    
    document.querySelector('[data-question="2"]').classList.remove('actived');
    document.querySelector('[data-question="3"]').classList.remove('actived');
    document.querySelector('[data-question="4"]').classList.remove('actived');
    document.querySelector('[data-question="5"]').classList.remove('actived');
    document.querySelector('[data-question="6"]').classList.remove('actived');

    this.question_1_init();
    this.arrowBtn();
  }

  SetQuestion2(value){
    this.Question2 = [];

    var Questions2 = []
    this.Question1.filter(function(line){
      if(line[0] == value){
        Questions2.push(line);
      }   
    });
    this.Question2 = Questions2;

    this.show_products = false;
    for (let i = 0; i < this.Question2.length; i++) {
      if(this.Question2[i][1] == ''){
        this.show_products = true;
      }
    }

    if(this.show_products){
      window.location.href = this.Question2[0][6];
    }else{

      var Question = this.Question2[0][1].split('::')[0];

      document.querySelector('[data-question-heading="2"]').innerHTML = Question;
      document.querySelector('[data-question="2"] .column-quizs-data_items').innerHTML = '';

      if(Question != "We don’t offer any system for you at the moment."){
        var Question2_item = []
        for (var j=0; j<this.Question2.length; j++) {
          var optionText = this.Question2[j][1].split('::')[1].trim();
          var imageUrl = this.Question2[j][1].split('::')[2];
          var imgTag = (imageUrl && imageUrl !== 'undefined') ? `<img src="${imageUrl}"/>` : '';
          
          if(!Question2_item.includes(optionText)){
            document.querySelector('[data-question="2"] .column-quizs-data_items').insertAdjacentHTML('beforeend', `
              <div class="column-quizs-data_items_child" data-value="${this.Question2[j][1]}">
                <span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_1136)">
                      <path class="inner_circle" d="M12 6.46875C8.68797 6.46875 5.99995 9.15677 5.99995 12.4688C5.99995 15.7808 8.68797 18.4687 12 18.4687C15.312 18.4687 18 15.7807 18 12.4687C18 9.15671 15.312 6.46875 12 6.46875Z" fill="#ED1C24"></path>
                      <path d="M12 0.46875C5.37001 0.46875 0 5.83876 0 12.4687C0 19.0987 5.37001 24.4687 12 24.4687C18.6299 24.4687 24 19.0987 24 12.4687C24 5.83871 18.63 0.46875 12 0.46875ZM12 22.0687C6.69599 22.0687 2.39996 17.7728 2.39996 12.4687C2.39996 7.16469 6.69599 2.86877 12 2.86877C17.3039 2.86877 21.6 7.16474 21.6 12.4687C21.6 17.7727 17.304 22.0687 12 22.0687Z" fill="#ED1C24"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_8_1136">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.46875)"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                ${optionText}
                ${imgTag}
              </div>
            `);
            Question2_item.push(optionText);
          }
        }
        this.question_2_init();
      }
      document.querySelector('[data-question="1"]').classList.add('hide');
      document.querySelector('[data-question="2"]').classList.add('actived');
      document.querySelector('[data-question="2"]').classList.remove('hide');
      document.querySelector('[data-question="3"]').classList.add('hide');
      document.querySelector('[data-question="4"]').classList.add('hide');
      document.querySelector('[data-question="5"]').classList.add('hide');
      document.querySelector('[data-question="6"]').classList.add('hide');
      
      document.querySelector('[data-question="3"]').classList.remove('actived');
      document.querySelector('[data-question="4"]').classList.remove('actived');
      document.querySelector('[data-question="5"]').classList.remove('actived');
      document.querySelector('[data-question="6"]').classList.remove('actived');
  
    }
    this.arrowBtn();
  }

  SetQuestion3(value){
    this.Question3 = [];

    var Questions3 = []
    this.Question2.filter(function(line){
      if(line[1] == value){
        Questions3.push(line);
      }   
    });
    this.Question3 = Questions3;

    this.show_products = false;
    for (let i = 0; i < this.Question3.length; i++) {
      if(this.Question3[i][2] == ''){
        this.show_products = true;
      }
    }

    if(this.show_products){
      window.location.href = this.Question3[0][6];
    }else{
      var Question = this.Question3[0][2].split('::')[0];

      document.querySelector('[data-question-heading="3"]').innerHTML = Question;
      document.querySelector('[data-question="3"] .column-quizs-data_items').innerHTML = '';

      if(Question != "We don’t offer any system for you at the moment."){
        var Question3_item = []
        for (var j=0; j<this.Question3.length; j++) {
          var optionText = this.Question3[j][2].split('::')[1].trim();
          var imageUrl = this.Question3[j][2].split('::')[2];
          var imgTag = (imageUrl && imageUrl !== 'undefined') ? `<img src="${imageUrl}"/>` : '';
          
          if(!Question3_item.includes(optionText)){
            debugger
            document.querySelector('[data-question="3"] .column-quizs-data_items').insertAdjacentHTML('beforeend', `
              <div class="column-quizs-data_items_child" data-value='${this.Question3[j][2]}'>
                <span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_1136)">
                      <path class="inner_circle" d="M12 6.46875C8.68797 6.46875 5.99995 9.15677 5.99995 12.4688C5.99995 15.7808 8.68797 18.4687 12 18.4687C15.312 18.4687 18 15.7807 18 12.4687C18 9.15671 15.312 6.46875 12 6.46875Z" fill="#ED1C24"></path>
                      <path d="M12 0.46875C5.37001 0.46875 0 5.83876 0 12.4687C0 19.0987 5.37001 24.4687 12 24.4687C18.6299 24.4687 24 19.0987 24 12.4687C24 5.83871 18.63 0.46875 12 0.46875ZM12 22.0687C6.69599 22.0687 2.39996 17.7728 2.39996 12.4687C2.39996 7.16469 6.69599 2.86877 12 2.86877C17.3039 2.86877 21.6 7.16474 21.6 12.4687C21.6 17.7727 17.304 22.0687 12 22.0687Z" fill="#ED1C24"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_8_1136">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.46875)"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                ${optionText}
                ${imgTag}
              </div>
            `);
            Question3_item.push(optionText);
          }
        }
        this.question_3_init();
      }
      document.querySelector('[data-question="1"]').classList.add('hide');
      document.querySelector('[data-question="2"]').classList.add('hide');
      document.querySelector('[data-question="3"]').classList.add('actived');
      document.querySelector('[data-question="3"]').classList.remove('hide');
      document.querySelector('[data-question="4"]').classList.add('hide');
      document.querySelector('[data-question="5"]').classList.add('hide');
      document.querySelector('[data-question="6"]').classList.add('hide');
      
      document.querySelector('[data-question="4"]').classList.remove('actived');
      document.querySelector('[data-question="5"]').classList.remove('actived');
      document.querySelector('[data-question="6"]').classList.remove('actived');
  
    }
    this.arrowBtn();
  }

  SetQuestion4(value){
    this.Question4 = [];

    var Questions4 = []
    this.Question3.filter(function(line){
      debugger
      if(line[2] == value){
        Questions4.push(line);
      }   
    });
    this.Question4 = Questions4;
    
    
    this.show_products = false;
    for (let i = 0; i < this.Question4.length; i++) {
      if(this.Question4[i][3] == ''){
        this.show_products = true;
      }
    }

    if(this.show_products){
      window.location.href = this.Question4[0][6];
    }else{
      debugger
      var Question = this.Question4[0][3].split('::')[0];

      document.querySelector('[data-question-heading="4"]').innerHTML = Question;
      document.querySelector('[data-question="4"] .column-quizs-data_items').innerHTML = '';
      
      if(Question != "We don’t offer any system for you at the moment."){
        var Question4_item = []
        for (var j=0; j<this.Question4.length; j++) {
          var optionText = this.Question4[j][3].split('::')[1].trim();
          var imageUrl = this.Question4[j][3].split('::')[2];
          var imgTag = (imageUrl && imageUrl !== 'undefined') ? `<img src="${imageUrl}"/>` : '';
          
          if(!Question4_item.includes(optionText)){
            document.querySelector('[data-question="4"] .column-quizs-data_items').insertAdjacentHTML('beforeend', `
              <div class="column-quizs-data_items_child" data-value="${this.Question4[j][3]}">
                <span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_1136)">
                      <path class="inner_circle" d="M12 6.46875C8.68797 6.46875 5.99995 9.15677 5.99995 12.4688C5.99995 15.7808 8.68797 18.4687 12 18.4687C15.312 18.4687 18 15.7807 18 12.4687C18 9.15671 15.312 6.46875 12 6.46875Z" fill="#ED1C24"></path>
                      <path d="M12 0.46875C5.37001 0.46875 0 5.83876 0 12.4687C0 19.0987 5.37001 24.4687 12 24.4687C18.6299 24.4687 24 19.0987 24 12.4687C24 5.83871 18.63 0.46875 12 0.46875ZM12 22.0687C6.69599 22.0687 2.39996 17.7728 2.39996 12.4687C2.39996 7.16469 6.69599 2.86877 12 2.86877C17.3039 2.86877 21.6 7.16474 21.6 12.4687C21.6 17.7727 17.304 22.0687 12 22.0687Z" fill="#ED1C24"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_8_1136">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.46875)"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                ${optionText}
                ${imgTag}
              </div>
            `);
            Question4_item.push(optionText);
          }
        }
        this.question_4_init();
      }
      document.querySelector('[data-question="1"]').classList.add('hide');
      document.querySelector('[data-question="2"]').classList.add('hide');
      document.querySelector('[data-question="3"]').classList.add('hide');
      document.querySelector('[data-question="4"]').classList.add('actived');
      document.querySelector('[data-question="4"]').classList.remove('hide');
      document.querySelector('[data-question="5"]').classList.add('hide');
      document.querySelector('[data-question="6"]').classList.add('hide');
      
      document.querySelector('[data-question="5"]').classList.remove('actived');
      document.querySelector('[data-question="6"]').classList.remove('actived');
      
      this.question_4_init();
    }
    this.arrowBtn();
  }

  SetQuestion5(value){
    this.Question5 = [];

    var Questions5 = []
    this.Question4.filter(function(line){
      if(line[3] == value){
        Questions5.push(line);
      }   
    });
    this.Question5 = Questions5;
    
    
    this.show_products = false;
    for (let i = 0; i < this.Question5.length; i++) {
      if(this.Question5[i][4] == ''){
        this.show_products = true;
      }
    }

    if(this.show_products){
      window.location.href = this.Question5[0][6];
    }else{
      var Question = this.Question5[0][4].split('::')[0];

      document.querySelector('[data-question-heading="5"]').innerHTML = Question;
      document.querySelector('[data-question="5"] .column-quizs-data_items').innerHTML = '';

      if(Question != "We don’t offer any system for you at the moment."){
        var Question5_item = []
        for (var j=0; j<this.Question5.length; j++) {
          var optionText = this.Question5[j][4].split('::')[1].trim();
          var imageUrl = this.Question5[j][4].split('::')[2];
          var imgTag = (imageUrl && imageUrl !== 'undefined') ? `<img src="${imageUrl}"/>` : '';
          
          if(!Question5_item.includes(optionText)){
            document.querySelector('[data-question="5"] .column-quizs-data_items').insertAdjacentHTML('beforeend', `
              <div class="column-quizs-data_items_child" data-value="${this.Question5[j][4]}">
                <span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_1136)">
                      <path class="inner_circle" d="M12 6.46875C8.68797 6.46875 5.99995 9.15677 5.99995 12.4688C5.99995 15.7808 8.68797 18.4687 12 18.4687C15.312 18.4687 18 15.7807 18 12.4687C18 9.15671 15.312 6.46875 12 6.46875Z" fill="#ED1C24"></path>
                      <path d="M12 0.46875C5.37001 0.46875 0 5.83876 0 12.4687C0 19.0987 5.37001 24.4687 12 24.4687C18.6299 24.4687 24 19.0987 24 12.4687C24 5.83871 18.63 0.46875 12 0.46875ZM12 22.0687C6.69599 22.0687 2.39996 17.7728 2.39996 12.4687C2.39996 7.16469 6.69599 2.86877 12 2.86877C17.3039 2.86877 21.6 7.16474 21.6 12.4687C21.6 17.7727 17.304 22.0687 12 22.0687Z" fill="#ED1C24"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_8_1136">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.46875)"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                ${optionText}
                ${imgTag}
              </div>
            `);
            Question5_item.push(optionText);
          }
        }
        this.question_5_init();
      }
      document.querySelector('[data-question="1"]').classList.add('hide');
      document.querySelector('[data-question="2"]').classList.add('hide');
      document.querySelector('[data-question="3"]').classList.add('hide');
      document.querySelector('[data-question="4"]').classList.add('hide');
      document.querySelector('[data-question="5"]').classList.add('actived');
      document.querySelector('[data-question="5"]').classList.remove('hide');
      document.querySelector('[data-question="6"]').classList.add('hide');
      
      document.querySelector('[data-question="6"]').classList.remove('actived');
  
    }
    this.arrowBtn();
  }

  SetQuestion6(value){
    this.Question6 = [];

    var Questions6 = []
    this.Question5.filter(function(line){
      if(line[4] == value){
        Questions6.push(line);
      }   
    });
    this.Question6 = Questions6;
    
    
    this.show_products = false;
    for (let i = 0; i < this.Question6.length; i++) {
      if(this.Question6[i][5] == ''){
        this.show_products = true;
      }
    }

    if(this.show_products){
      window.location.href = this.Question6[0][6];
    }else{
      var Question = this.Question6[0][5].split('::')[0];

      document.querySelector('[data-question-heading="6"]').innerHTML = Question;
      document.querySelector('[data-question="6"] .column-quizs-data_items').innerHTML = '';
      
      if(Question != "We don’t offer any system for you at the moment."){
        var Question6_item = []
        for (var j=0; j<this.Question6.length; j++) {
          var optionText = this.Question6[j][5].split('::')[1].trim();
          var imageUrl = this.Question6[j][5].split('::')[2];
          var imgTag = (imageUrl && imageUrl !== 'undefined') ? `<img src="${imageUrl}"/>` : '';
          
          if(!Question6_item.includes(optionText)){
            document.querySelector('[data-question="6"] .column-quizs-data_items').insertAdjacentHTML('beforeend', `
              <div class="column-quizs-data_items_child" data-value="${this.Question6[j][5]}">
                <span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_1136)">
                      <path class="inner_circle" d="M12 6.46875C8.68797 6.46875 5.99995 9.15677 5.99995 12.4688C5.99995 15.7808 8.68797 18.4687 12 18.4687C15.312 18.4687 18 15.7807 18 12.4687C18 9.15671 15.312 6.46875 12 6.46875Z" fill="#ED1C24"></path>
                      <path d="M12 0.46875C5.37001 0.46875 0 5.83876 0 12.4687C0 19.0987 5.37001 24.4687 12 24.4687C18.6299 24.4687 24 19.0987 24 12.4687C24 5.83871 18.63 0.46875 12 0.46875ZM12 22.0687C6.69599 22.0687 2.39996 17.7728 2.39996 12.4687C2.39996 7.16469 6.69599 2.86877 12 2.86877C17.3039 2.86877 21.6 7.16474 21.6 12.4687C21.6 17.7727 17.304 22.0687 12 22.0687Z" fill="#ED1C24"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_8_1136">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.46875)"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                ${optionText}
                ${imgTag}
              </div>
            `);
            Question6_item.push(optionText);
          }
        }
        this.question_6_init();
      }
      document.querySelector('[data-question="1"]').classList.add('hide');
      document.querySelector('[data-question="2"]').classList.add('hide');
      document.querySelector('[data-question="3"]').classList.add('hide');
      document.querySelector('[data-question="4"]').classList.add('hide');
      document.querySelector('[data-question="5"]').classList.add('hide');
      document.querySelector('[data-question="6"]').classList.add('actived');
      document.querySelector('[data-question="6"]').classList.remove('hide');
  
    }
    this.arrowBtn();
  }

  SetProducts(value){
    this.Products = [];

    var Product = []
    this.Question6.filter(function(line){
      if(line[5] == value){
        Product.push(line);
      }   
    });
    this.Products = Product;

    window.location.href = this.Products[0][6];
  }
}


customElements.define('custom-quiz', Quiz);


